import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ConstructorContent as SchemaConstructorContent } from '../schemas/ConstructorContent';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Constructor
 */
export const GetConstructorVersionContentContentType = '' as const;
export type GetConstructorVersionContentRequest = void;
export type GetConstructorVersionContentResponses = LinkCommonErrorResponses & {
    /**
     * @description Constructor content with specified version
     */
    '200': {
        'application/json': SchemaConstructorContent;
    };
    /**
     * @description Specified constructor version not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetConstructorVersionContentResponseSuccess =
    GetConstructorVersionContentResponses['200']['application/json'];
export type GetConstructorVersionContentSearchParams = undefined;
export type GetConstructorVersionContentPathParameters = {
    id: number;
};
export const GetConstructorVersionContentUrl = '/constructor/versions/{id}/content' as const;
export const GetConstructorVersionContentMethod = 'GET' as const;
export const getGetConstructorVersionContentUrl = (params: GetConstructorVersionContentPathParameters) =>
    GetConstructorVersionContentUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetConstructorVersionContentPathParameters) => String(params[param])
    );
